<template>
  <div class="container">
    <img class="close" v-if="isClose" @click="$emit('close')" src="@/assets/images/login/icon-close.png" alt="">
    <div class="tabs">
      <div class="tabsItem" v-for="(item, index) in ['账号密码登录', 'APP扫码登录']" :key="index"
        :class="active == index ? 'active' : ''" @click="active = index">
        <span>{{ item }}</span>
      </div>
    </div>
    <div class="control" :style="active == 1 ? 'min-height: 234px;' : ''">
      <template v-if="active == 0">
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form ">
          <el-form-item prop="account">
            <el-input v-model="loginForm.account" type="text" auto-complete="off" placeholder="账号">
              <img slot="prefix" src="@/assets/images/login/icon-user.png" class="input-img" />
              <div slot="prefix" class="line"></div>
            </el-input>
          </el-form-item>
          <el-form-item prop="password" class="mt-3">
            <el-input v-model="loginForm.password" @keyup.enter.native="handleLogin" type="password" auto-complete="off" placeholder="密码">
              <img slot="prefix" src="@/assets/images/login/icon-pwd.png" class="input-img" />
              <div slot="prefix" class="line"></div>
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="mt-5 flex justify-center">
              <div class="loginBtn" @click="handleLogin" v-if="!loading">
                <span>登&nbsp;&nbsp;&nbsp;&nbsp;录</span>
              </div>
              <div class="loginBtn" v-else>
                <span>登&nbsp;&nbsp;录&nbsp;&nbsp;中...</span>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </template>
      <template v-if="active == 1">
        <div class="flex align-center justify-center" style="width: 100%;height: 100%;">
          <img src="@/assets/images/login/code.png" style="height: 100%;" alt="">
        </div>
      </template>
    </div>
    <div class="footer mt-3">
      <img src="@/assets/images/login/code.png" alt="">
      <div class="footerRight">
        <span>扫描左侧二维码，</span>
        <span style="margin-top: 5px;">下载【平安堆龙app】</span>
      </div>
    </div>
  </div>
</template>

<script>
import { encrypt } from "@/utils/jsencrypt";
export default {
  props:{
    isClose:{
      type:Boolean,
      default:false
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('手机号为空'));
      } else {
        const reg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (!reg.test(value)) {
          callback(new Error('手机号不正确'));
        } else {
          callback();
        }
      }
    };
    return {
      active: 0,
      loading: false,
      loginForm: {
        account: '',
        password: '',
      },
      loginRules: {
        phone: [
          { validator: validatePhone, trigger: "blur" },
        ],
        account: [
          { required: true, message: '账号不能为空', trigger: "blur" },
          { pattern: /^[a-zA-Z0-9]+$/, message: '请输入正确格式的账号', trigger: "blur" }],
        password: [
          { required: true, message: '密码不能为空', trigger: "blur" },
          // {pattern:/^[a-zA-Z0-9!@#$%^&*_]+$/,message:'请输入正确格式的密码',trigger: "blur"}
        ],
        code: [{ required: true, trigger: "change", message: "验证码不能为空" }]
      },
    }
  },
  mounted() {

  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.loginForm.password = encrypt(this.loginForm.password)
          this.$store.dispatch("LoginByAccount", this.loginForm).then(() => {
            this.$router.push({ path: '/jump' }).catch(err => { })
          }).catch(() => {
            this.loading = false;
            this.loginForm = this.$options.data().loginForm;
          });
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  padding: 93px 63px 54px;
  margin-top: 116px;
  margin-right: 147px;
  width: 511px;
  height: 571px;
  background-image: url('../../../assets/images/login/right-bj.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
.close{
  cursor: pointer;
  position: absolute;
  top: 31px;
  right: 37px;
  width: 24px;
  height: 24px;
}
  .tabs {
    display: flex;
    justify-content: space-around;
    align-items: center;

    .tabsItem {
      cursor: pointer;
      color: #4B7198;
      font-size: 20px;
    }

    .active {
      color: #ABD4FF;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: -20px;
        transform: translateX(-50%);
        display: block;
        width: 150px;
        height: 13px;
        background-image: url('../../../assets/images/login/active-bottom.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
    }
  }

  .control {
    flex: 1;
    margin-top: 46px;

    .input-img {
      width: 30px;
      height: 30px;
      // border-right: 1px solid #317DBA;
    }

    .line {
      margin-left: 16px;
      width: 1px;
      height: 25px;
      background: #317dba;
    }

    ::placeholder {
      font-size: 16px;
      color: #5B688C;
    }

    /deep/.el-input__prefix {
      width: 61px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    /deep/.el-input--prefix .el-input__inner {
      padding-left: 80px;
      font-size: 16px;
      width: 385px;
      height: 52px;
      background: #0C2640;
      border: 1px solid #297bc7;
      box-shadow: 0px 0px 4px #297bc740;
      color: #ABD4FF !important;
    }

    .loginBtn {
      cursor: pointer;
      width: 200px;
      height: 50px;
      background-image: url('../../../assets/images/login/btn.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      text-align: center;
      line-height: 50px;

      span {
        color: #5debfe;
        font-size: 16px;
      }
    }
  }

  .footer {
    width: 100%;
    height: 105px;
    background: #0F2E50;
    padding: 17px 38px;
    display: flex;
    align-items: center;

    img {
      width: 90px;
      height: 90px;
      border-radius: 2px;
      margin-right: 40px;
    }

    .footerRight {
      display: flex;
      flex-direction: column;

      span {
        color: #ffffff;
        font-size: 17px;
      }
    }
  }
}

/deep/.el-form-item {
  margin-bottom: 0px;
}
</style>